import { Box } from '@mui/material'
import { Theme } from 'app/shared/utils'
import styled from 'styled-components'

export const OrderItemContainer = styled(Box)`
    border-radius: 5px;
    &:hover {
        background-color: #eaecef7a;
    }
`